<label>
  <input [value]="value" [name]="formControlName" (change)="change()" type="radio" #input />
  <div class="checked"></div>

  <span class="label">
    <ng-container *ngIf="label">{{ label }}</ng-container>
    <ng-container *ngIf="!label"><ng-content></ng-content></ng-container>
  </span>
</label>
